import router from '@/router/index';
import {WatchNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs } = api;
    let here = parent.active;

    here.init
      .to(here.watch);
    here.watch
      .to()
      .when(messageIs(ResumeFsm))
      .effect(({context},{watch})=>{
        context.commit('login/watch/setAllWatches',watch,{root:true});
        router.push({name:WatchNavigation})
      });
  }
};
